export default __webpack_public_path__ + "static/media/attribution.69b9bcbc.txt";